import type { ReactNode } from 'react'

import { usePageType } from '@/src/general/hooks/usePageType'
import { PageTypeScreenBackground } from '@/src/general/ui/layouts/AppLayout/PageTypeBackground'

/**
 * screenLayout that paints page-type chrome inside each navigator scene.
 * Must sit inside React Navigation’s Background (opaque theme) so the gradient wash is
 * visible without making sibling scenes transparent.
 */
export const usePageTypeScreenLayout = () => {
  const { background } = usePageType()

  return ({ children }: { children: ReactNode }) => (
    <PageTypeScreenBackground background={background}>{children}</PageTypeScreenBackground>
  )
}
